import { useState, useEffect } from 'react';
import { useSwiper } from 'swiper/react';

// The Swiper library's useSwiper appears to be a reactive hook that will trigger re-renders when values like swiper.activeIndex
// changes, but it actually is not. See https://github.com/nolimits4web/swiper/issues/5577
// This little hook creates a reactive version of useSwiper by forcing a state change any time the swiper value changes
// (thus forcing a re-render of any components that depend on values like swiper.activeIndex)
export const useSwiperReactive = () => {
  const swiper = useSwiper();

  // Use any state value to force a re-render, but we don't actually care about the value itself
  const [, setSignal] = useState({});
  const forceRerender = () => setSignal({});

  useEffect(() => {
    if (swiper) {
      swiper.on('slideChange', forceRerender);
    }
  }, []);

  return swiper;
};
